export function inSourcelessIFrame(): boolean {
    return (
        window.self !== window.top &&
        !!window.frameElement &&
        (window.frameElement as HTMLIFrameElement).src === 'about:blank'
    )
}
